import { useMutation, useQueryClient } from "@tanstack/react-query";
import API from "../../api/API";
import { getErrorMessage } from "../../../utils/GeneralUtils";
import { TenantInfo } from "../../../types/TenantInterfaces";

export interface FavoritePayload {
  action: "add" | "remove";
  cloudID: string;
}

interface Props {
  payload: FavoritePayload;
}

// Logic for favoriting/unfavoriting clouds in the Cloud Switcher
export default function useFavoriteCloud() {
  const client = useQueryClient();

  const favoriteCloud = useMutation({
    mutationFn: ({ payload }: Props) => {
      return API.favoriteCloud(payload);
    },
    onMutate: ({ payload }) => {
      const previousClouds = client.getQueryData<TenantInfo[]>(["clouds"]);

      if (!previousClouds) return;

      const cloudsCopy = structuredClone(previousClouds);

      const newClouds = cloudsCopy.map((c: TenantInfo) => {
        if (c.TenantID === payload.cloudID) {
          c.Favorite = payload.action === "add" ? true : false;
        }

        return c;
      });

      client.setQueryData(["clouds"], newClouds);

      return { previousClouds };
    },
    onError: (err, _, context) => {
      console.log(getErrorMessage(err));

      if (context) {
        client.setQueryData(["clouds"], context.previousClouds);
      }
    },
  });

  return {
    favoriteCloud: favoriteCloud.mutate,
  };
}
